import type { GenerationRuleForm } from './generation-rule-dialog'

export const GENERATION_RULE_PRESETS = [
  'custom',
  'per_work_period',
  'per_work_period_rests',
  'six_hour',
  'eight_hour',
] as const

export type GenerationRulePreset = (typeof GENERATION_RULE_PRESETS)[number]

/** The rule form a preset starts from. Codes and the active flag are kept, so
 * switching presets never drops what was already picked. */
export function presetRuleValues(
  preset: GenerationRulePreset,
  values: GenerationRuleForm
): GenerationRuleForm {
  const perWorkPeriod: Partial<GenerationRuleForm> = {
    kind: 'diet',
    rule: 'per_work_period',
    amount: 1,
    perDurationHours: null,
  }
  switch (preset) {
    case 'custom':
      return values
    case 'per_work_period':
    case 'per_work_period_rests':
      return { ...values, ...perWorkPeriod }
    case 'six_hour':
      return { ...values, kind: 'diet', rule: 'six_hour_quarter' }
    case 'eight_hour':
      return { ...values, kind: 'diet', rule: 'eight_hour_third' }
  }
}

/** The modifier a preset adds beside its rule: week rests under 96 hours on the
 * salary setting get one diet per full 24 hours, at most 3 per rest, on the
 * rule's code. */
export function presetModifierInput(
  preset: GenerationRulePreset,
  salaryWorkTimeId: string,
  name: string
) {
  if (preset !== 'per_work_period_rests') return null
  return {
    name,
    kind: 'diet',
    appliesTo: 'rest',
    salaryWorkTime: salaryWorkTimeId,
    maxDurationHours: 96,
    award: 'award',
    amount: 1,
    perDurationHours: 24,
    rounding: 'floor',
    maxAmount: 3,
    isActive: true,
  }
}
